import React from "react";
import { useDispatch } from "react-redux";

import { ColumnContainer } from "utils/columnsStyle";

import EditIcon from "@mui/icons-material/Edit";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import ImageIcon from "@mui/icons-material/Image";

import { editCapture } from "redux/actions/buildings/captures/capturesActions";
import { CAPTURES_CONFIG, CAPTURES_PHRASE } from "./config";
import RegularButton from "components/CustomButtons/Button";
import { blue } from "@mui/material/colors";

export const columns = [
  {
    Header: () => <span>{CAPTURES_CONFIG.apartment.label}</span>,
    accessor: CAPTURES_CONFIG.apartment.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[CAPTURES_CONFIG.apartment.key]
        ? row[CAPTURES_CONFIG.apartment.key]
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{CAPTURES_CONFIG.customer.label}</span>,
    accessor: CAPTURES_CONFIG.customer.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[CAPTURES_CONFIG.customer.key]
        ? row[CAPTURES_CONFIG.customer.key]
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{CAPTURES_CONFIG.meter.label}</span>,
    accessor: CAPTURES_CONFIG.meter.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[CAPTURES_CONFIG.meter.key]
        ? row[CAPTURES_CONFIG.meter.key]
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{CAPTURES_CONFIG.captureDate.label}</span>,
    accessor: CAPTURES_CONFIG.captureDate.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[CAPTURES_CONFIG.captureDate.key]
        ? row[CAPTURES_CONFIG.captureDate.key]
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{CAPTURES_CONFIG.currentCapture.label}</span>,
    accessor: CAPTURES_CONFIG.currentCapture.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[CAPTURES_CONFIG.currentCapture.key]
        ? row[CAPTURES_CONFIG.currentCapture.key]
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{CAPTURES_CONFIG.capture.label}</span>,
    accessor: CAPTURES_CONFIG.capture.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[CAPTURES_CONFIG.capture.key]
        ? row[CAPTURES_CONFIG.capture.key]
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{CAPTURES_CONFIG.total.label}</span>,
    accessor: CAPTURES_CONFIG.total.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[CAPTURES_CONFIG.total.key]
        ? row[CAPTURES_CONFIG.total.key]
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{CAPTURES_CONFIG.average.label}</span>,
    accessor: CAPTURES_CONFIG.average.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[CAPTURES_CONFIG.average.key]
        ? row[CAPTURES_CONFIG.average.key]
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{CAPTURES_CONFIG.status.label}</span>,
    accessor: CAPTURES_CONFIG.status.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[CAPTURES_CONFIG.status.key]
        ? row[CAPTURES_CONFIG.status.key]
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        : ""
  },

  {
    Header: () => <span>Acciones</span>,
    filterable: false,
    sortable: false,
    Cell: ({ original }) => {
      const dispatch = useDispatch();
      const openEdit = () => {
        original.modal();
        dispatch(editCapture(original));
      };
      const handleCancel = () => {
        original.cancel(original.id, original.idRouteCycle);
      };
      const handleImage = () => {
        original.imageModal(original.imageUrl);
      };
      return (
        <ColumnContainer>
          <RegularButton
            tooltip={CAPTURES_PHRASE.page.table.actions.edit}
            round
            justIcon
            color="transparent"
            size="sm"
            onClick={openEdit}
          >
            <EditIcon style={{ color: blue[500] }} />
          </RegularButton>
          <RegularButton
            tooltip={CAPTURES_PHRASE.page.table.actions.cancel}
            round
            justIcon
            color="transparent"
            size="sm"
            onClick={handleCancel}
          >
            <HighlightOffIcon style={{ color: blue[500] }} />
          </RegularButton>
          <RegularButton
            tooltip={CAPTURES_PHRASE.page.table.actions.image}
            round
            justIcon
            color="transparent"
            size="sm"
            onClick={handleImage}
          >
            <ImageIcon style={{ color: blue[500] }} />
          </RegularButton>
        </ColumnContainer>
      );
    }
  }
];
